export default __webpack_public_path__ + "static/media/home_bg.a6124c6f.jpg";